import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { P, Span } from '..';

export function UserFundraiserSkeleton() {
    return <React.Fragment>
        {[...Array(6)].map((e, index) => {
            return <div className="donation-single" >
                <div className="dcontent">
                    <div className="donatepic">
                        <a href="/">
                            <Skeleton count={1} height={160} />
                        </a>
                    </div>
                    <div className="meta">
                        <div className="donateto">
                            <a href="/"><Skeleton count={1} width={'100%'} /></a>
                            <P>
                                <div>
                                    <P><Skeleton count={1} width={100} /><Skeleton count={1} width={'40%'} /></P>
                                </div>
                            </P>
                        </div>
                        <div className="raisedtype">
                            <Span className="raisedtype-left"><Skeleton count={1} width={70} /></Span>
                            <Span className="raisedtype-left"><Skeleton count={1} width={70} /></Span>
                            <Span className="raisedtype-right"><Skeleton count={1} width={70} /></Span>
                        </div>
                        <div className="dedit">
                            <P><Skeleton count={1} width={70} /><Skeleton count={1} width={70} /></P>
                        </div>
                    </div>
                </div>
            </div>
        })}
    </React.Fragment>
}